import React, { FC, useMemo } from 'react'

import { parseButtonColor } from '@Components/Button'
import { BuyButton } from '@Components/BuyButton'
import { BuyButtonV1Props } from '@Components/BuyButton/v1'
import { Block } from '@Generated/graphql'
import { getJSONFieldValue, getProductReferenceValue } from '@Globals/CMS/FieldHelpers'

import styles from './BuyButtonBlock.module.scss'

interface BuyButtonBlockProps {
  buyButtonBlock: Block
  id?: string
}

const getBlockData = (buyButtonBlock: Block): BuyButtonV1Props | undefined => {
  // @ts-ignore // Because "BuyButtonColor" does not satisfy JSONType because it can be undefined, but we'll fall back to "var(--primary)" in that case.
  const buttonColor = getJSONFieldValue<BuyButtonProps['buttonColor']>(buyButtonBlock.fields || [], 'buttonColor') || undefined
  const buttonText = getJSONFieldValue<string>(buyButtonBlock.fields || [], 'buttonText') || undefined
  const showPrice = getJSONFieldValue<boolean>(buyButtonBlock.fields || [], 'showPrice') || false
  const products = getProductReferenceValue(buyButtonBlock.fields || [], 'products')

  const product = products[0]
  if (!product) {
    return undefined
  }

  const isSaleable = product.availability?.isInStock || false

  // In order to support the "default" button color-setting, we'll just unset it and let
  // the button element deal with it itself.
  const colorToUse = parseButtonColor(buttonColor)

  return {
    buttonColor: colorToUse,
    buttonText,
    isSaleable,
    product,
    showPrice,
  }
}

const BuyButtonBlock: FC<BuyButtonBlockProps> = ({ buyButtonBlock, id }) => {
  const data = useMemo(() => getBlockData(buyButtonBlock), [buyButtonBlock])
  if (!data) {
    return null
  }
  // @ts-ignore
  return <BuyButton {...data} className={styles.buyButtonBlock} id={id} />
}

export default BuyButtonBlock
